import { userService } from "../services";
import config, { apiName } from "../config/config";

export const VehicleAction = {
  fetchVehicleList,
  saveUser,
  fetchById,
  userActiveInactive,
  updateUser,
  vehicleTypeList,
  fetchTerminalSiteTypeList,
  VehicleRefresh,
  etpOrderFetch,
  VehicleGpsRemove,
  vehicleMaintanceList,
  addOrUpdateMaintance,
  fetchVehicleList2,
  fetchVehicleTransactions,
  cehckGpsRefId,
  updateVehicleIsDesignated,
  fetchGpsTrailById,
  fetchDepartmentList,
  vehicleSubTypeList,
  fetchVehicleListDropdown,
};

async function updateVehicleIsDesignated(payload) {
  try {
    let apiEndpoint = `${config.baseUrl}${apiName.removeGpsFromVehicle}?companyId=${payload.companyId}&id=${payload.id}&userName=${payload.userName}&remark=${payload.remark}&imageUrl=${payload.imageUrl}`;
    const response = await userService.get(apiEndpoint);
    if (response.status === 200) {
      // Assuming a successful response has status 200
      return response.data; // Return the response data
    } else {
      return null; // Return null if the response status is not 200
    }
  } catch (err) {
    console.error("Error in updateVehicleIsDesignated:", err); // Log any errors for debugging
    return null; // Return null if an error occurs
  }
}

async function fetchVehicleListDropdown(payload, showSnackbar) {
  try {
    let data = {
      onlyGpsVehicle: payload.onlyGpsVehicle,
    };

    let apiEndpoint = `${config.baseUrl}${config.apiName.VehicleDropdown}`;

    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchVehicleList(payload, showSnackbar) {
  try {
    let data = {
      company: {
        id: payload.companyId,
      },
      number: payload.number,
      IMEI: payload.IMEI,
      vehicleActualTypeDTO: {
        id: payload.vehicleType,
      },
      driver: {
        name: payload.driver,
      },
      site: {
        id: payload.siteId,
      },
      vendorId: payload.vendorId ? payload.vendorId : "",
      siteIds: payload.siteIds,
      userId: payload.userId,
      onlyGpsVehicle: payload.onlyGpsVehicle,
      allVehicle: payload.allVehicle,
      blacklisted: payload.blacklisted,
      fuelSensorEnabled: payload.fuelSensorEnabled,
      vehicleMaintenanceCategory: payload.vehicleMaintenanceCategory,
      runningStatus: payload.runningStatus,
      isRunning: payload.isRunning,
      getBlackListedVehicle: payload.getBlackListedVehicle,
      mineName: payload.mineName,
      mineId: payload.mineId,
      nitId: payload.nitId,
      departmentId: payload.departmentId,
      forDropDown: payload.forDropDown,
      firmwareVersion: payload?.firmwareVersion
        ? payload?.firmwareVersion
        : null,

      nitNumber: payload.nitNumber ? payload.nitNumber : null,
    };

    let apiEndpoint = `${config.baseUrl}${config.apiName.VehicleList}?pageSize=${payload.pageSize}&pageNo=${payload.pageNo}`;

    debugger;
    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchVehicleList2(payload, showSnackbar) {
  try {
    let data = {
      company: {
        id: payload.companyId,
      },
      number: payload.number,
      vehicleType: {
        id: payload.vehicleType,
      },
      driver: {
        name: payload.driver,
      },
      site: {
        id: payload.siteId,
      },
      vendorId: payload.vendorId ? payload.vendorId : "",
      siteIds: payload.siteIds,
      userId: payload.userId,
      onlyGpsVehicle: payload.onlyGpsVehicle,
      allVehicle: payload.allVehicle,
      fuelSensorEnabled: payload.fuelSensorEnabled,
      vehicleMaintenanceCategory: payload.vehicleMaintenanceCategory,
      runningStatus: payload.runningStatus,
      isRunning: payload.isRunning,
      getBlackListedVehicle: payload.getBlackListedVehicle,
    };

    let apiEndpoint = `${config.baseUrl}${config.apiName.VehicleList2}?pageSize=${payload.pageSize}&pageNo=${payload.pageNo}`;

    debugger;
    let response = await userService.post(apiEndpoint, data);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function updateUser(payload, showSnackbar) {
  console.log(payload);
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.UpdateVehicle}`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if ((response && response.status == 200) || response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function saveUser(payload, showSnackbar) {
  console.log(payload);
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.AddVehicle}`;
    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    debugger;
    if (response && response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function userActiveInactive(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.ActiveVehicle}`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function addOrUpdateMaintance(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.maintenanceAdd}`;

    let response = await userService.post(apiEndpoint, payload);
    console.log(response);
    if ((response && response.status == 200) || response.status == 201) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchById(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.VehicleById}?id=${payload.userId}&companyId=${payload.companyId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response?.status == 200) {
      return response?.data || [];
    } else {
      // console.log(response);
      // showSnackbar(response?.data?.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
async function fetchGpsTrailById(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.gpsTrailList}?vehicleId=${payload.vehicleId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response?.status == 200) {
      return response?.data || [];
    } else {
      // console.log(response);
      // showSnackbar(response?.data?.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function cehckGpsRefId(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.checkgpsRefId}?vehicleId=${payload.id}&fromDate=${payload.fromDate}&toDate=${payload.toDate}`;

    let response = await userService.get(apiEndpoint);
    console.log(response, "dxcfgvhbjnkml");
    if (response && response?.status == 200 && response?.data !== "") {
      return response?.data || [];
    } else {
      // console.log(response);
      showSnackbar(response?.data?.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function vehicleTypeList(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.VehicleTypeList}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchTerminalSiteTypeList(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.fetchTerminalSiteTypeList}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function vehicleSubTypeList(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.vehicleSubTypeList}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function vehicleMaintanceList(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.maintenanceVehicleList}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function VehicleRefresh(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.SyncVehicle}?vehicleNo=${payload.vehicleNo}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function VehicleGpsRemove(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.removeGpsFromVehicle}?companyId=${payload.companyId}&id=${payload.vehicleId}`;

    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");

      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function etpOrderFetch(payload, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.EtpOrder}?orderId=${payload.orderId}&companyId=${payload.companyId}`;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchVehicleTransactions(vehicleId, showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.fetchVehicleTransactions}?vehicleId=${vehicleId}`;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}

async function fetchDepartmentList(showSnackbar) {
  try {
    let apiEndpoint = `${config.baseUrl}${config.apiName.fetchDepartmentList}`;
    let response = await userService.get(apiEndpoint);
    console.log(response);
    if (response && response.status == 200) {
      return response.data;
    } else {
      console.log(response);
      showSnackbar(response.data.message, "error");
      return null;
    }
  } catch (error) {
    console.log("error", error);
    return null;
  }
}
